<template>
  <div class="h5customization">
    <div class="notaryServices_content_title">定制化公证咨询服务</div>
    <div class="notaryServices_gzzx">
      <div class="notaryServices_gzzxtext">
        <el-form
          ref="ruleFormRef"
          :model="ruleForm"
          :rules="rules"
          label-width="100px"
          class="demo-ruleForm"
          label-position="top"
          status-icon
        >
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="咨询地区：" prop="dqdm">
                <el-cascader
                  :teleported="false"
                  class="h40"
                  size="large"
                  placeholder="请选择咨询地区"
                  ref="cascaderZxdq"
                  filterable
                  style="height: 40px; width: 100%;font-size: 16px;"
                  v-model="ruleForm.dqdm"
                  :options="areaData"
                  :props="{ value: 'code', label: 'name' }"
                  @change="handlezxdq"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="咨询业务：" prop="zxyw">
                <el-cascader
                  :teleported="false"
                  class="h40"
                  placeholder="请选择咨询业务"
                  ref="cascaderYwzx"
                  filterable
                  style="height: 40px; width: 100%;font-size: 16px;"
                  v-model="ruleForm.zxyw"
                  :options="ywzx"
                  :props="{ value: 'name', label: 'name', children: 'children' }"
                  @change="handleywzx"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="公司名称：" prop="gsmc">
                <el-input v-model="ruleForm.gsmc" placeholder="请输入公司名称" style="height: 40px;font-size: 16px;" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="公司职务：" prop="gszw">
                <el-input v-model="ruleForm.gszw" placeholder="请输入公司职务" style="height: 40px;font-size: 16px;" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="姓　　名：" prop="xm">
                <el-input v-model="ruleForm.xm" placeholder="请输入姓名" style="height: 40px;font-size: 16px;" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="手机号码：" prop="lxsjh">
                <el-input v-model="ruleForm.lxsjh" placeholder="请输入手机号码" style="height: 40px;font-size: 16px;" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="咨询内容：" prop="zxnr">
                <el-input
                  style="font-size: 16px;"
                  v-model="ruleForm.zxnr"
                  :autosize="{ minRows: 7, maxRows: 7 }"
                  type="textarea"
                  placeholder="请输入想要咨询公证的业务诉求"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <div class="btnH5"  @click="submitForm(ruleFormRef)">
              立即提交咨询
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentInstance, ref, onMounted } from "vue";

export default {
  name: "Customization",
  props: { themeColor: { type: String, default: 'blue' } },
  setup() {
    const { proxy } = getCurrentInstance();
    const ruleFormRef = ref(null);
    const ruleForm = ref({ dqdm: [], zxyw: [] });
    const cascaderZxdq = ref(null);
    const cascaderYwzx = ref(null);
    const areaData = ref([]);

    // 咨询业务数据
    const ywzx = ref([
      {
        name: "公证事项",
        children: [
          { name: "合同公证" }, { name: "继承公证" }, { name: "意定公证" },
          { name: "财产公证" }, { name: "商事公证" }, { name: "亲属公证" },
          { name: "身份公证" }, { name: "章程公证" }, { name: "证据公证" }, { name: "文证公证" }
        ]
      },
      {
        name: "公证事务",
        children: [
          { name: "法定登记" }, { name: "提存事务" }, { name: "保管事务" },
          { name: "文书代拟" }, { name: "公证法律" }
        ]
      }
    ]);

    // 表单验证规则
    const rules = ref({
      xm: [{ required: true, message: "请输入姓名", trigger: "blur" }],
      lxsjh: [
        { required: true, message: "请输入联系手机号", trigger: "blur" },
        { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码", trigger: "blur" }
      ],
      dqdm: [{ required: true, message: "请选择咨询地区", trigger: "change" }],
      zxyw: [{ required: true, message: "请选择咨询业务", trigger: "change" }],
      zxnr: [{ required: true, message: "请输入咨询内容", trigger: "blur" }]
    });

    // 地区选择处理
    const handlezxdq = () => {
      const nodes = cascaderZxdq.value?.getCheckedNodes();
      if (nodes && nodes.length) {
        const labels = nodes[0].pathLabels;
        ruleForm.value.zxdq = labels[labels.length - 1];
      }
    };

    const handleywzx = () => {
      // 业务选择处理（可选）
    };

    // 模拟地区树数据（实际可替换为接口调用）
    const loadAreaData = () => {
      // 模拟省市区数据
      areaData.value = [
        { code: '440000', name: '广东省', children: [
          { code: '440100', name: '广州市', children: [{ code: '440105', name: '海珠区' }] },
          { code: '440300', name: '深圳市', children: [{ code: '440305', name: '南山区' }] }
        ] },
        { code: '310000', name: '上海市', children: [
          { code: '310100', name: '市辖区', children: [{ code: '310101', name: '黄浦区' }] }
        ] }
      ];
    };

    // 提交表单
    const submitForm = async (formEl) => {
      if (!formEl) return;
      await formEl.validate(async (valid, fields) => {
        if (valid) {
          // 处理提交数据
          const submitData = { ...ruleForm.value };
          // 地区取最后一级code
          if (Array.isArray(submitData.dqdm) && submitData.dqdm.length) {
            submitData.dqdm = submitData.dqdm[submitData.dqdm.length - 1];
          }
          // 业务取完整路径用“-”连接
          if (Array.isArray(submitData.zxyw) && submitData.zxyw.length) {
            submitData.zxyw = submitData.zxyw.join('-');
          }
          // 模拟接口调用（可替换为真实请求）
          try {
            // 模拟请求延迟
            await new Promise(resolve => setTimeout(resolve, 500));
            console.log('提交数据:', submitData);
            proxy.$message({ type: "success", message: "提交成功" });
            ruleForm.value = { dqdm: [], zxyw: [] };
            ruleFormRef.value?.resetFields();
          } catch (err) {
            proxy.$message({ type: "error", message: "提交失败，请重试" });
          }
        } else {
          console.log('表单验证失败', fields);
        }
      });
    };

    onMounted(() => {
      loadAreaData();
    });

    return {
      ruleForm,
      ruleFormRef,
      ywzx,
      areaData,
      rules,
      cascaderZxdq,
      cascaderYwzx,
      handlezxdq,
      handleywzx,
      submitForm
    };
  }
};
</script>

<style lang="less" scoped>
.h5customization {
  width: 100%;
  background: #F9FAFC;
  padding-bottom: 50px;
  .notaryServices_content_title {
   font-size: .36rem;
  color: #1A1A1A;
  line-height: .56rem;
    font-weight: 600;
   padding: .6rem .28rem 0 .28rem;
   background: #F9FAFC;
  }
  .notaryServices_gzzx {
    display: flex;
    margin-top: 30px;
    .notaryServices_gzzximg {
      width: 386px;
      height: 444px;
      .notaryServices_background {
        width: 100%;
        height: 100%;
        background: linear-gradient(135deg, #0754BD, #2b7ae0);
        border-radius: 20px 0 0 20px;
        font-size: 34px;
        color: #FFFFFF;
        padding-left: 46px;
        padding-top: 235px;
        .notaryServices_background_text1 { margin-top: 9px; font-weight: 600; }
      }
    }
    .notaryServices_gzzxtext {
      flex: 1;
      background: #F9FAFC; 
      padding: 28px 30px 0 30px;
    }
  }
  :deep(.h40) .el-input__inner { height: 40px;font-size: 16px; }
:deep(.el-cascader-menu)   {min-width: 2.38rem !important;}
.btnH5 {
 width: 2.68rem;
 height: .8rem;
  font-size: .28rem;
  color: #FFFFFF;
  line-height: .8rem;
  text-align: center;
  cursor: pointer;
  border-radius: .4rem;
  border: .02rem solid #191919;
  color: #191919;
  transition: opacity 0.3s;
  &:hover { opacity: 0.85; }
}
}


</style>